import React from 'react';
import { format, subMonths, addMonths } from 'date-fns';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const MonthSelector = ({ selectedMonth, onChange }) => {
  const currentDate = new Date(selectedMonth + '-01');

  const handlePreviousMonth = () => {
    const newDate = subMonths(currentDate, 1);
    onChange(format(newDate, 'yyyy-MM'));
  };

  const handleNextMonth = () => {
    const newDate = addMonths(currentDate, 1);
    onChange(format(newDate, 'yyyy-MM'));
  };

  return (
    <div className="flex items-center gap-4">
      <button
        onClick={handlePreviousMonth}
        className="p-2 hover:bg-gray-100 rounded-full"
      >
        <FaChevronLeft className="w-4 h-4 text-gray-600" />
      </button>
      
      <input
        type="month"
        value={selectedMonth}
        onChange={(e) => onChange(e.target.value)}
        className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
      />
      
      <button
        onClick={handleNextMonth}
        className="p-2 hover:bg-gray-100 rounded-full"
      >
        <FaChevronRight className="w-4 h-4 text-gray-600" />
      </button>
    </div>
  );
};

export default MonthSelector; 